<footer class="main-footer">
    <div class="container-dynamic d-flex">
      <span class="m-auto"></span>
      Designed and Developed by <a href="https://varuna-sentinels.com/" target="_blank" rel="noopener">&nbsp;Varuna Sentinels BV</a>
    </div>
  </footer>